export default "/images/a55e39738727d094591ab35534cc1167.avif";